const DEFAULT_MENU_ICON = "lucide:circle";

export const mapMenusToSidebarConfig = (menus = []) => {
    const childrenByParentId = {};
    const rootMenus = [];

    (menus || []).filter((menu) => (menu.active ?? true) && !menu.deleted)
        .forEach((menu) => {
            if (menu.parentId === null || menu.parentId === undefined) {
                rootMenus.push(menu);
            } else {
                (childrenByParentId[menu.parentId] ??= []).push(menu);
            }
        });

    const bySeq = (a, b) => (a.sequence ?? 0) - (b.sequence ?? 0);

    const items = rootMenus.sort(bySeq).map((menu) => {
        const children = (childrenByParentId[menu.id] || []).sort(bySeq);

        if (children.length > 0) {
            return {
                menuKey: `menu-${menu.id}`,
                menuTitle: menu.name,
                menuIcon: menu.icon || DEFAULT_MENU_ICON,
                count: menu.count,
                children: children.map((child) => ({
                    menuKey: `menu-${child.id}`,
                    subMenuName: child.name,
                    navigationPath: child.link,
                    ...(child.icon ? { menuIcon: child.icon } : {}),
                })),
            };
        }

        return {
            menuKey: `menu-${menu.id}`,
            menuTitle: menu.name,
            count: menu.count,
            menuIcon: menu.icon || DEFAULT_MENU_ICON,
            navigationPath: menu.link,
        };
    });

    return [{ items }];
};
